
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "AccordionContainerHeaderLabel4008190829",
      {"classes":{"root":"AccordionContainerHeaderLabel4008190829__root"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  